var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class LRUCache {
  constructor(maxSize) {
    this.maxSize = maxSize;
    __publicField(this, "cache", /* @__PURE__ */ new Map());
  }
  get(key) {
    const value = this.cache.get(key);
    if (value !== void 0) {
      this.cache.delete(key);
      this.cache.set(key, value);
    }
    return value;
  }
  set(key, value) {
    if (this.cache.has(key)) {
      this.cache.delete(key);
    } else if (this.cache.size === this.maxSize) {
      this.cache.delete(this.getOldestKey());
    }
    this.cache.set(key, value);
  }
  getOldestKey() {
    return this.cache.keys().next().value;
  }
}
export {
  LRUCache
};
//# sourceMappingURL=LRUCache.js.map
